/** Shared checks for bus attendant portal (vehicle tracking). */
export function isBusAttendantUser(user) {
  if (!user) return false
  const ut = String(user.user_type || '').toLowerCase()
  if (ut === 'bus_attendant') return true
  const roles = (user.roles || []).map((r) => String(r).toLowerCase())
  return roles.includes('bus_attendant')
}

/** Admin / superadmin keeps staff transport views even if they also have bus_attendant. */
export function isAdminLikeUser(user) {
  if (!user) return false
  const ut = String(user.user_type || '').toLowerCase()
  const roles = (user.roles || []).map((r) => String(r).toLowerCase())
  return (
    ut === 'admin' ||
    ut === 'superadmin' ||
    roles.includes('admin') ||
    roles.includes('superadmin')
  )
}

/** Attendant-only users should use the attendant portal route, not the staff track page. */
export function shouldRedirectBusAttendantToPortal(user) {
  return isBusAttendantUser(user) && !isAdminLikeUser(user)
}

/** Landing route after login and for dashboard/root guards */
export const BUS_ATTENDANT_HOME_ROUTE = '/AttendantPortal'
